import { render, staticRenderFns } from "./ignoreList.vue?vue&type=template&id=4c1df67f&scoped=true"
import script from "./ignoreList.vue?vue&type=script&lang=js"
export * from "./ignoreList.vue?vue&type=script&lang=js"
import style0 from "./ignoreList.vue?vue&type=style&index=0&id=4c1df67f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1df67f",
  null
  
)

export default component.exports